import { type CustomEventData } from 'types/customEventData';

export class MessageEventService {
  private static instance: MessageEventService | null = null;

  private listeners: Set<(data: CustomEventData) => void>;

  private constructor() {
    this.listeners = new Set();

    MessageEventService.instance = this;

    window.addEventListener('message', this.handleMessage);
  }

  public static getInstance = (): MessageEventService => {
    if (MessageEventService.instance) {
      return MessageEventService.instance;
    }

    return new MessageEventService();
  };

  public postMessage = (targetWindow: Window, data: CustomEventData): void => {
    targetWindow?.postMessage?.(data, '*');
  };

  public subscribe = (listener: (data: CustomEventData) => void): void => {
    this.listeners.add(listener);
  };

  public unsubscribe = (listener: (data: CustomEventData) => void): void => {
    this.listeners.delete(listener);
  };

  public close = (): void => {
    window.removeEventListener('message', this.handleMessage);
    this.listeners.clear();
    MessageEventService.instance = null;
  };

  private handleMessage = (event: MessageEvent<CustomEventData>): void => {
    const { data } = event;
    // Distribute the message to all listeners
    this.listeners.forEach((listener) => {
      listener(data);
    });
  };
}
